<template>
  <div class="header-container">
    <!-- header -->
    <div class="header">
      <div class="logo">
        <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747138980459/WechatIMG10244.jpg" alt="">
        蓝泰检测
      </div>
      <div class="header-nav">
        <div 
          class="nav-item" v-for="(item,index) in navData" 
          :key="index" :class="{'item-cur': item.isClick}" 
          @click="handleNavChoose(index, 'parent')"
          @mouseenter="item.isShow = true"
          @mouseleave="item.isShow = false"
        >
          {{ currentLanguage == 'en'? item.enLabel : item.label }}
            <!-- 展示内容 -->
          <div class="item-child-content">
            <div class="child-content">
              <div class="child-content-left">
                <div class="left-title">
                  蓝泰检测 <span>/ {{ currentLanguage == 'en'? item.enLabel : item.label}}</span>
                </div>
                <p>{{ $language === 'en'? 'Multi industry third-party testing institutions provide one-stop testing services' : '多行业的第三方检测机构，提供一站式检测服务' }}</p>
                <!-- child -->
                <div class="child-items">
                  <div class="child-item" v-for="(child,index) in item.children" :key="index" @click.stop="handleChildChoose(child.value)">
                    {{ currentLanguage == 'en'? child.enLabel : child.label }}
                  </div>
                </div>
              </div>
              <!-- right-content -->
              <div class="child-content-right">
                <img class="right-img" src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747058367590/WechatIMG10297.jpg" alt="">
                <p>"公正准确 客户至上 责任担当 安全诚信”</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bannerComponentVue></bannerComponentVue>
  </div>
</template>
<script>
  import bannerComponentVue from '../../components/newHomeComponents/bannerComponent.vue'
  export default {
    name: 'Header',
    components: {
      bannerComponentVue
    },
    data() {
      return {
        navData: [{
          label: '首页',
          value: 'index',
          enLabel: 'Home',
          isClick: true,
          isShow: false,
        }, {
          label: '关于我们',
          value: 'aboutUs',
          enLabel: 'About Us',
          isClick: false,
          isShow: false,
          children: [
            {
              label: '关于我们',
              value: 'about',
              enLabel: 'About Us',
            },{
              label: '企业资质',
              value: 'qualifications',
              enLabel: 'Qualifications'
            },{
              label: '企业文化',
              value: 'culture',
              enLabel: 'Culture'
            }
          ]
        },{
          label: '蓝泰服务',
          value: 'PTC',
          enLabel: 'Core Services',
          isClick: false,
          isShow: false,
          children: [
            {
              label: '检测类别',
              value: 'category',
              enLabel: 'Test category'
            },{
              label: '检测项目',
              value: 'project',
              enLabel: 'Testing items'
            },{
              label: '各国认证',
              value: 'case',
              enLabel: 'Certification countries'
            }
          ]
        },{
          label: '证书查询',
          value: 'certificateQuery',
          enLabel: 'Certificate Query',
          isClick: false,
          isShow: false,
          children: [
            {
              label: '报告查询',
              value: 'report',
              enLabel: 'Report inquiry'
            },
            // {
            //   label: '历史报告查询',
            //   value: 'history',
            //   enLabel: 'Historical report query'
            // }
          ]
        }, 
        // {
        //   label: '新闻资讯',
        //   value: 'newsInformation',
        //   enLabel: 'News and Information',
        //   isClick: false,
        //   isShow: false,
        //   children: [
        //     {
        //       label: '行业资讯',
        //       value: 'information',
        //       enLabel: 'Industry Information'
        //     },{
        //       label: '公司新闻',
        //       value: 'news',
        //       enLabel: 'Company News'
        //     },{
        //       label: '通知公告',
        //       value: 'notice',
        //       enLabel: 'Notice'
        //     }
        //   ]
        // },
        {
          label: '联系我们',
          value: 'contact',
          enLabel: 'Contact Us',
          isClick: false
        },{
          label: '加入我们',
          value: 'joinUs',
          enLabel: 'Join Us',
          isClick: false
        },{
          label: 'English',
          value: 'en',
          enLabel: 'English',
          isClick: false
        },{
          label: '中文',
          value: 'zh',
          enLabel: '中文',
          isClick: false
        }],//导航条
        currentLanguage: sessionStorage.getItem('language') || 'zh', //当前语言
      }
    },
    mounted () {
      // 头部数据缓存
      let storageData = sessionStorage.getItem('navData')
      if(storageData&&storageData.length>0){ //有本地缓存
        this.navData = JSON.parse(storageData)
        console.log(this.$language, '有缓存')
      } else { //没有本地缓存
        sessionStorage.setItem('navData',JSON.stringify(this.navData))
        console.log(this.$language, '无缓存')
      }
      console.log('被触发')
    },
    methods: {
      // 一级菜单选择
      handleNavChoose (index , type) {
        this.navData.forEach((item,i) => {
          item.isClick = false
          if(i === index){
            item.isClick = true
            if (type === 'parent' && index < 6) {
              this.handleRouter(item.value)
            } else {
              this.handleLanguage(index)
            }
          }
        })
        
        sessionStorage.setItem('navData',JSON.stringify(this.navData))
      },
      // 语言设置
      handleLanguage (index) {
        const _this = this
        console.log(_this.navData[index])
        let str = _this.navData[index].value
        sessionStorage.setItem('language',str)
        this.currentLanguage = str
        window.location.reload()
      },
      // 二级菜单选择
      handleChildChoose (value) {
        switch (value) {
          case 'about':
            this.routerLink('/about');
            break;
          case 'qualifications':
            this.routerLink('/about/qualifications');
            break;
          case 'culture':
            this.routerLink('/about/culture');
            break;
          case 'category':
            this.childType = 'category'
            break;
          case 'project':
            this.childType = 'project'
            break;
          case 'case':
            this.childType = 'case'
            break;
          case 'contact':
            this.childType = 'contact'
            break;
          case 'report':
            window.location.href = 'http://www.ptc-testing.cn:8094/ReportManage/ReportQuery/Authenticity'
            break;
          case 'history':
            this.routerLink('/history');
            break;
          case 'information':
            this.childType = 'information'
            break;
          case 'news':
            this.childType = 'news'
            break;
          case 'notice':
            this.childType = 'notice'
            break;
          default:
            console.log('error')
            break;
        }
      },
      // 路由跳转
      handleRouter (value) {
        switch (value) {
          case 'index':
            this.routerLink('/')
            break;
          case 'aboutUs':
            this.routerLink('/about')
            break;
          case 'contact':
            this.routerLink('/contact')
            break;
          case 'newsInformation':
            this.routerLink('/news')
            break;
          case 'certificateQuery':
            this.routerLink('/report')
            break;
          case 'joinUs':
            this.routerLink('/JoinUs')
            break;
          case 'PTC':
            this.routerLink('/PTC')
            break;
          default:
            console.log('error')
            break;
        }
      },
      // 跳转
      routerLink (path, query) {
        this.$router.push({path: path, query: query})
      },
      handleMouseEnter (item) {
        if (item.children && item.children.length > 0) {
          item.isShow = true
        }
      },
    }
  }
</script>
<style scoped>
.header{
  width: 100%;
  height: 95px;
  background: #fff;
  padding: 0 180px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  box-shadow: 0px 4px 10px 0px rgba(221,221,221,0.302);
}
.logo{
  width: 280px;
  font-weight: 500;
  font-size: 35px;
  color: #333;
  display: flex;
  align-items: center;
}
.logo > img{
  width:80px;
}
.header-nav{
  width: 800px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav-item{
  font-size: 16px;
  font-weight: 350;
  color: #282828;
  cursor: pointer;
}
.nav-item:hover{
  color: #2D73FF;
}
.item-cur{
  color: #2D73FF;
  border-bottom: 4px solid #2D73FF;
}
.nav-item:hover .item-child-content{
  transform: translateY(0);
  visibility: visible;
  opacity: 1;
  background-color: rgba(0, 46, 125, 0.8);
}
.item-child-content{
  width: 100%;
  height: 360px;
  color: #fff;
  position: absolute;
  top: 95px;
  left: 0px;
  box-shadow: 0 2px 29px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  transform: translateY(50px);
  transition: all .7s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-delay: .2s;
  transition-duration: .4s;
  visibility: hidden;
  opacity: 0;
  width: 100%;
  z-index: 9999;
  color: #fff;
}
.child-content{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.child-content-left{
  width: 500px;
  text-align: left;
}
.left-title{
  font-size: 42px;
  color: #ffffff;
  font-weight: bold;
}
.left-title span{
  font-size: 18px;
}
.child-content-left p{
  line-height: 28px;
  font-size: 16px;
  color: #ffffff;
  opacity: .7;
}
.child-items{
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.child-item{
  padding: 10px 28px;
  text-transform: capitalize;
  display: block;
  background-color: #189bf0;
  margin-right: 10px;
  
}
.child-content .right-img{
  height: 228px;
  width: 400px;
  object-fit: cover;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Header.vue